import { MenuLateral } from "@/components/shared/MenuLateral"
import { ComposicaoCPG } from "@/pages/PosGraduacao/ComposicaoCPG"
import { DocentePlenoPosGraduacao } from "@/pages/PosGraduacao/DocentePlenoPosGraduacao"
import { Route, Routes } from "react-router-dom"


const EstudeConoscoPosGraduacaoRoutes = () => {
    return (
        <div className='flex'>

            <MenuLateral
                title="Pós-graduação - Estude Conosco"
                menuType="feagri-posgraduacao-estu"
            />

            <div className='pl-10'>
                <Routes>
                    <Route path='/corpo-docente/docente-pleno-posgraduacao' element={<DocentePlenoPosGraduacao />} />
                    <Route path='/comissao/composicao-cpg' element={<ComposicaoCPG />} />
                </Routes>
            </div>
        </div>
    )
}

export { EstudeConoscoPosGraduacaoRoutes };